const name = 'BaseSkew';
const properties = {};
function animate(kit, elements, duration = 0, delay = 0, params = {}) {
    return kit.engine.tween(elements, { duration, delay, ...params }, [
        'skewX',
        'skewY',
    ]);
}
export { name, properties, animate };
//# sourceMappingURL=baseSkew.js.map